module.exports = __webpack_public_path__ + "img/fda-logo.cee97b0c.png";